import { render, staticRenderFns } from "./PageTableSort.vue?vue&type=template&id=23a850f1&scoped=true&"
import script from "./PageTableSort.vue?vue&type=script&lang=js&"
export * from "./PageTableSort.vue?vue&type=script&lang=js&"
import style0 from "./PageTableSort.vue?vue&type=style&index=0&id=23a850f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a850f1",
  null
  
)

export default component.exports